import axios from 'axios';
import type { XProcess } from '@/models/xprocess';

class XProcessWebservice {
    public load(withLessons: boolean = false) {
        return axios.get<XProcess[]>('/xprocesses', {
            params: {
                withLessons,
            },
        });
    }

    public getById(xProcessId: string) {
        return axios.get<XProcess>('/xprocesses/getById', {
            params: {
                xProcessId,
            },
        });
    }

    public store(xProcess: XProcess) {
        return axios.post('/xprocesses/store', {
            title: xProcess.title,
            description: xProcess.description,
            order: xProcess.order,
            abbreviation: xProcess.abbreviation,
        });
    }

    public update(xProcess: XProcess) {
        return axios.post('/xprocesses/update', {
            id: xProcess.id,
            title: xProcess.title,
            description: xProcess.description,
            order: xProcess.order,
            abbreviation: xProcess.abbreviation,
        });
    }

    public remove(xProcess: XProcess) {
        return axios.post('/xprocesses/remove', {
            id: xProcess.id,
        });
    }
}

export const xProcessWebservice = new XProcessWebservice();
